import axios from '@/axios.js'
let safe = 'd86f4d7f-65d3-413e-aed4-2ae3816d5145'

export default {
  getListOfProductFromOperation({commit},id){
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/etransport/getlistprod/${id}`)
        .then((response) => {
          commit('SET_PRODUCTLIST', response.data)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getListOfOperationNearToday({commit}){
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/etransport/getlistinvoice`)
        .then((response) => {
          commit('SET_OPERATIONTLIST', response.data)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getListOfTransportNearToday({commit}){
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/etransport/getlisttransport`)
        .then((response) => {
          commit('SET_TRANSPORTLIST', response.data)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getETransportList({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/etransport/displaymessagestest/${safe}`, item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  uploadETransportXML({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/anaf/etransport/uploadxml/${safe}`, item)
        .then((response) => {
          console.log(response.data)
          resolve(response)
        })
        .catch((error) => {
          alert(JSON.stringify(error))
          console.log(error)
          reject(error)
        })
    })
  },
  downloadEfactura({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/anaf/displayinvoice/${item.id}/${item.id_solicitare}`,
        method: 'GET',
        data: item,
        responseType: 'blob', // Important pour traiter la réponse comme un flux binaire
      })
      .then((response) => {
        // Créer un URL pour le blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // Créer un élément de lien pour le téléchargement
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'efactura.pdf'); // Nom du fichier à télécharger
        document.body.appendChild(link);
        link.click(); // Simuler un clic pour télécharger le fichier
        link.parentNode.removeChild(link); // Nettoyer en supprimant l'élément de lien
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },
  getStockRefresh({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/server/stock/data`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getServerStatus({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/server/data`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  InsertEFactura({ commit },  {item}) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/inputinvoice/${item.id}/${item.id_solicitare}/${item.cui}/${item.dt}`)
        .then((response) => {
          commit('REMOVE_PENDING_INVOICE', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  InsertEFacturaOld({ commit },  {item}) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/inputinvoiceold/${item.id}/${item.id_solicitare}/${item.cui}/${item.dt}`)
        .then((response) => {
          //alert(JSON.stringify(response))
          /*const messagesFiltres = response.data.filter(data => data.tip === 'FACTURA PRIMITA').sort((a, b) => b.id - a.id);
          commit('SET_DOWNLOADINVOICE', messagesFiltres)*/
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  loadKPI({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/loadkpi/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  testXMLEfactura({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/anaf/testfile`,
        method: 'POST',
        data: item,
        responseType: 'blob', // Important pour traiter la réponse comme un flux binaire
      })
      .then((response) => {
        // Créer un URL pour le blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // Créer un élément de lien pour le téléchargement
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf'); // Nom du fichier à télécharger
        document.body.appendChild(link);
        link.click(); // Simuler un clic pour télécharger le fichier
        link.parentNode.removeChild(link); // Nettoyer en supprimant l'élément de lien
        resolve(response);
      })
      // Pas d'alert() ici : le store ne sait pas POURQUOI ça a échoué. C'est à
      // la vue d'afficher le message typé renvoyé par l'API (mixin efacturaError).
      .catch((error) => {
        console.error("testXMLEfactura:", error);
        reject(error);
      });
    });
  },

  // Validation ANAF SANS téléchargement : l'envoi groupé valide N factures, il
  // ne peut pas déverser N PDF dans le dossier de l'opérateur. Même endpoint,
  // même écriture de `efactura_test` que `testXMLEfactura` — c'est le flag
  // `nopdf` qui change la réponse (JSON au lieu du fichier).
  testXMLEfacturaSilent({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/anaf/testfile`, Object.assign({}, item, { nopdf: true }))
        .then((response) => resolve(response))
        .catch((error) => {
          console.error("testXMLEfacturaSilent:", error)
          reject(error)
        })
    })
  },

  uploadInvoiceXMLEfactura({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/anaf/uploadxml/${safe}`, item)
        .then((response) => {
          console.log(response.data)
          resolve(response)
        })
        // Idem : « POST ISSUE » masquait aussi bien une adresse manquante qu'un
        // refus de l'ANAF ou une coupure réseau. La vue décide quoi afficher.
        .catch((error) => {
          console.error("uploadInvoiceXMLEfactura:", error)
          reject(error)
        })
    })
  },
  // Outil correction TVA bois de feu : envoi manuel d'un XML brut (test/prod), sans écrire dans operations
  sendRawXmlEfactura({ commit }, item) {
    // item = { xmldata, mode }
    return new Promise((resolve, reject) => {
      axios.post(`/anaf/rawxml/upload/${safe}`, item)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getRawXmlStatusEfactura({ commit }, payload) {
    // payload = { mode, id }
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/rawxml/status/${payload.mode}/${payload.id}/${safe}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  // scope 'all' = toutes les factures RO depuis 2025, validées comprises
  // (centralisateur) ; sans scope, seulement celles qui restent à envoyer.
  uploadInvoiceList({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/invoicetobesent`, { params: payload.scope ? { scope: payload.scope } : {} })
        .then((response) => {
          commit('SET_UPLOADLISTEFACTURA', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  downloadInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/displaymessages/${safe}`)
        .then((response) => {
          const messagesFiltres = response.data.filter(data => data.tip === 'FACTURA PRIMITA').sort((a, b) => b.id - a.id);
          commit('SET_DOWNLOADINVOICE', messagesFiltres)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  downloadinvoicestreated({ commit }, { month, year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/invoicetreated/${month}/${year}`) // Inclut le mois et l'année dans l'URL
        .then((response) => {
          commit('SET_DOWNLOADINVOICESTREADTED', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadinvoicestreatedyear({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/invoicetreated/${year}`) // Inclut le mois et l'année dans l'URL
        .then((response) => {
          commit('SET_DOWNLOADINVOICESTREADTED', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getTokenInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/gettokentest/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  manageAnafToken({ commit },  code) {
    return new Promise((resolve, reject) => {
      axios.get(`/anaf/gettoken/${safe}/${code}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  loadActiveRequisition({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/seeactivereq/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTransactions({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/gettransactions/${safe}/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchMonthlyExpenses({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/monthlyexpenses/${year}/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpenseDetail({ commit }, { year, month }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expensedetail/${year}/${month}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpenseExport({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expenseexport/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpenseRecap({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expenserecap/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  createManualTx({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/manualtx/${safe}`, payload)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchManualTx({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expense/manualtx/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  deleteManualTx({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gcl/expense/manualtx/${id}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchBankSyncHealth({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/banksynccheck/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  setExpenseComment({ commit }, { gcl_id, comment }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/comment/${safe}`, { gcl_id, comment })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  setExpenseExcluded({ commit }, { gcl_id, excluded }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/exclude/${safe}`, { gcl_id, excluded })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  setExpenseInvestment({ commit }, { gcl_id, is_investment }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/investment/${safe}`, { gcl_id, is_investment })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchInvestments({ commit }, { year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expense/investments/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchCreditOps({ commit }, { kind, year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expense/credit/${kind}/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  previewEjectRule({ commit }, { field, value, mode }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/ejectpreview/${safe}`, { field, value, mode })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  createEjectRule({ commit }, { field, value, mode, note }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gcl/expense/ejectrule/${safe}`, { field, value, mode, note })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchEjectRules({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expense/ejectrules/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  fetchRuleMatches({ commit }, { id, year }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/expense/rulematches/${id}/${year}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  deleteEjectRule({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gcl/expense/ejectrule/${id}/${safe}`)
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  updateIbanFirst({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/ibanfirst/readmail`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateTransactions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/updatetransactions/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBalance({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/updatebalance/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  refreshAccount({ commit }, { accountid }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/refreshaccount/${accountid}/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteConnection({ commit }, { bankid, pin }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gcl/connection/${bankid}/${pin}/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchConnectedBankData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/getbank/${safe}`)
        .then((response) => {
          commit('SET_BANK', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchConnectedAccountAndBankData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/getbankandaccount/${safe}`)
        .then((response) => {
          commit('SET_ACCOUNT_BANK', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAccounts({ commit }, bank_id) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/getaccount/${bank_id}/${safe}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchInstitutions({ commit }, country) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/getinstitutions/${country}/${safe}`)
        .then((response) => {
          commit('SET_INSITUTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createAgreement({ commit }, { institution_id, gcl_bic, gcl_name, gcl_logo }) {
    return new Promise((resolve, reject) => {
      axios.get(`/gcl/createenduseragreement/${institution_id}/${gcl_bic}/${gcl_name}/${gcl_logo.replace(/\//g, '@')}/${safe}`)
        .then((response) => {
          if (response.data && response.data.link) {
            window.location.href = response.data.link
            resolve(response)
          } else {
            reject(new Error("No agreement link returned"))
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
